// src/pages/admin/DashboardFooter.js
import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const DashboardFooter = () => (
  <Footer style={{ textAlign: 'center', backgroundColor: '#f0f2f5', padding: '10px 0', fontSize: window.innerWidth < 768 ? '12px' : '14px' }}>
    JectHub Admin Dashboard © {new Date().getFullYear()} Created by xAI
  </Footer>
);

export default DashboardFooter;